export default [
  {
    rid: 2,
    name: 'Super User',
    link: '/admin/genie/admins/super',
    genieSettings: {
      outOfOffice: false,
      level: 'Senior',
      preferredPartners: [],
      preferredLenders: [],
      __typename: 'GenieSettings'
    },
    portfolio: {
      value: 0,
      numActiveLoans: 0,
      leftUntilCap: 0,
      percentageOfCap: 0,
      averageSmartRate: 0,
      loansLast30: 0,
      loansLast4: 0,
      loansAssignedToday: 0,
      shortTermThrottled: false,
      __typename: 'Portfolio'
    },
    __typename: 'Administrator'
  },
  {
    rid: 4,
    name: 'Partner Manager',
    link: '/admin/genie/admins/4',
    genieSettings: null,
    portfolio: {
      value: 0,
      numActiveLoans: 0,
      leftUntilCap: 0,
      percentageOfCap: 0,
      averageSmartRate: 0,
      loansLast30: 0,
      loansLast4: 0,
      loansAssignedToday: 0,
      shortTermThrottled: false,
      __typename: 'Portfolio'
    },
    __typename: 'Administrator'
  },
  {
    rid: 9,
    name: 'Frank RM',
    link: '/admin/genie/admins/9',
    genieSettings: {
      outOfOffice: true,
      level: 'Senior',
      preferredPartners: [],
      preferredLenders: [
        'First Home',
        'Five Star',
        'Seacoast'
      ],
      __typename: 'GenieSettings'
    },
    portfolio: {
      value: 0,
      numActiveLoans: 0,
      leftUntilCap: 30,
      percentageOfCap: 0,
      averageSmartRate: 0,
      loansLast30: 0,
      loansLast4: 0,
      loansAssignedToday: 0,
      shortTermThrottled: false,
      __typename: 'Portfolio'
    },
    __typename: 'Administrator'
  },
  {
    rid: 10,
    name: 'Grace RM',
    link: '/admin/genie/admins/10',
    genieSettings: null,
    portfolio: {
      value: 0,
      numActiveLoans: 0,
      leftUntilCap: 0,
      percentageOfCap: 0,
      averageSmartRate: 0,
      loansLast30: 0,
      loansLast4: 0,
      loansAssignedToday: 0,
      shortTermThrottled: false,
      __typename: 'Portfolio'
    },
    __typename: 'Administrator'
  },
  {
    rid: 11,
    name: 'Heidi RM',
    link: '/admin/genie/admins/11',
    genieSettings: null,
    portfolio: {
      value: 0,
      numActiveLoans: 0,
      leftUntilCap: 0,
      percentageOfCap: 0,
      averageSmartRate: 0,
      loansLast30: 0,
      loansLast4: 0,
      loansAssignedToday: 0,
      shortTermThrottled: false,
      __typename: 'Portfolio'
    },
    __typename: 'Administrator'
  },
  {
    rid: 12,
    name: 'Janet RM',
    link: '/admin/genie/admins/12',
    genieSettings: null,
    portfolio: {
      value: 0,
      numActiveLoans: 0,
      leftUntilCap: 0,
      percentageOfCap: 0,
      averageSmartRate: 0,
      loansLast30: 0,
      loansLast4: 0,
      loansAssignedToday: 0,
      shortTermThrottled: false,
      __typename: 'Portfolio'
    },
    __typename: 'Administrator'
  },
  {
    rid: 13,
    name: 'Mallory RM',
    link: '/admin/genie/admins/13',
    genieSettings: null,
    portfolio: {
      value: 0,
      numActiveLoans: 0,
      leftUntilCap: 0,
      percentageOfCap: 0,
      averageSmartRate: 0,
      loansLast30: 0,
      loansLast4: 0,
      loansAssignedToday: 0,
      shortTermThrottled: false,
      __typename: 'Portfolio'
    },
    __typename: 'Administrator'
  },
  {
    rid: 14,
    name: 'Oscar RM',
    link: '/admin/genie/admins/14',
    genieSettings: null,
    portfolio: {
      value: 0,
      numActiveLoans: 0,
      leftUntilCap: 0,
      percentageOfCap: 0,
      averageSmartRate: 0,
      loansLast30: 0,
      loansLast4: 0,
      loansAssignedToday: 0,
      shortTermThrottled: false,
      __typename: 'Portfolio'
    },
    __typename: 'Administrator'
  },
  {
    rid: 15,
    name: 'Pat RM',
    link: '/admin/genie/admins/15',
    genieSettings: null,
    portfolio: {
      value: 0,
      numActiveLoans: 0,
      leftUntilCap: 0,
      percentageOfCap: 0,
      averageSmartRate: 0,
      loansLast30: 0,
      loansLast4: 0,
      loansAssignedToday: 0,
      shortTermThrottled: false,
      __typename: 'Portfolio'
    },
    __typename: 'Administrator'
  },
  {
    rid: 16,
    name: 'Sybil RM',
    link: '/admin/genie/admins/16',
    genieSettings: null,
    portfolio: {
      value: 0,
      numActiveLoans: 0,
      leftUntilCap: 0,
      percentageOfCap: 0,
      averageSmartRate: 0,
      loansLast30: 0,
      loansLast4: 0,
      loansAssignedToday: 0,
      shortTermThrottled: false,
      __typename: 'Portfolio'
    },
    __typename: 'Administrator'
  },
  {
    rid: 17,
    name: 'Trudy RM',
    link: '/admin/genie/admins/17',
    genieSettings: null,
    portfolio: {
      value: 0,
      numActiveLoans: 0,
      leftUntilCap: 0,
      percentageOfCap: 0,
      averageSmartRate: 0,
      loansLast30: 0,
      loansLast4: 0,
      loansAssignedToday: 0,
      shortTermThrottled: false,
      __typename: 'Portfolio'
    },
    __typename: 'Administrator'
  },
  {
    rid: 18,
    name: 'Victor RM',
    link: '/admin/genie/admins/18',
    genieSettings: null,
    portfolio: {
      value: 0,
      numActiveLoans: 0,
      leftUntilCap: 0,
      percentageOfCap: 0,
      averageSmartRate: 0,
      loansLast30: 0,
      loansLast4: 0,
      loansAssignedToday: 0,
      shortTermThrottled: false,
      __typename: 'Portfolio'
    },
    __typename: 'Administrator'
  }
]
